import moment from "moment";
import React, { ReactElement } from "react";
import Avatar from "react-avatar";
import { Col, Row } from "react-bootstrap";

import { ProjectTaskAction } from ".";

interface IProps {
	actions: ProjectTaskAction[];
}

export const ProjectTaskActionList = (props: IProps): ReactElement => {
	if (!props.actions) {
		return <strong>No Activity available</strong>;
	}

	const actionEls = props.actions.map((action, index) => {
		return (
			<Row className="action-log-item" key={index}>
				<Col sm={1} className="avatar-column">
					<Avatar
						round
						key={index}
						name={action.user ? action.user.fullName : "NA"}
						size="30"
						color="#dfe1e6"
						fgColor="#172b4d"
						textSizeRatio={2}
					/>
				</Col>
				<Col>
					<strong>{action.user ? action.user.fullName : "NA"}</strong>{" "}
					{action.getReadableMessage()}
					<small>{moment(action.createdAt).fromNow()}</small>
				</Col>
			</Row>
		);
	});

	return <div>{actionEls}</div>;
};
